<template>
  <transition mode="in-out" @leave="leave" :css="false">
    <section class="intro">
      <div class="intro__bg">
        <div class="intro__bg-view">
          <div class="intro__bg-view-con">
            <video src="/intro.mp4" muted playsinline autoplay/>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
  import {mapMutations} from 'vuex';
  import promokit from '@/utils/promokit';
  import gsap from "gsap";

  export default {
    name: "intro",
    data(){
      return{
        name:'intro',
        isMobile:promokit.util.isMobile(),
        isMuted:true
      }
    },
    methods:{
      ...mapMutations([
        'setIsIntro'
      ]),

      leave(el, done){

        gsap.delayedCall(0.5, ()=>{
          done()
        } );
      },
      movePage(){
       // this.setIsLayer(false)
      },
      setMuted(){
        if(this.isMuted){
          this.isMuted = false;
          document.querySelector('.intro__bg-view-con video').muted = false;
        }else{
          this.isMuted = true;
          document.querySelector('.intro__bg-view-con video').muted = true;
        }
      }
    },
    beforeDestroy(){

     // this.setIsLayer(false)
    },
    mounted() {

     // this.setIsLayer(true)
     // gsap.from(document.querySelector('.intro__skip-btn'), 0.5, {y:50, autoAlpha:0, ease:'expo.easeInOut', delay:1});
      document.querySelector('.intro__bg-view-con video').playbackRate = 4;
       document.querySelector('.intro__bg-view-con video').addEventListener('ended', ()=>{
         this.movePage();
       })

    }
  }
</script>

<style lang="scss">
  .intro {
    position:fixed;
    background: #000;
    width:100%;
    height:100%;
    top:0;
    left:0;
    &__bg {
      @include position($width: 100%, $height: 100%);
      // min-height: 900px;
      overflow: hidden;

      &-view {
        @include position($position: absolute, $top: 0, $left: 0, $width: 100%, $height: 100%);

        &-con {
          @include position($position: absolute, $top: 0, $left: 0, $width: 100%, $height: 100%);

          video {
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          &:after{
            @include position($position: absolute, $top: 0, $left: 0, $width: 100%, $height: 100%);
         //   @include bg($bg: '../assets/img/bg_cover.png', $cover:cover);
            content:'';
          }
        }
      }
    }
  }

</style>
